// src/pages/WholesaleOrder.js
import React, { useEffect, useState, useMemo } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
  addDoc,
  serverTimestamp,
  where,
  doc,
  getDoc,
} from "firebase/firestore";
import { FaBoxOpen, FaSave, FaCheck, FaTruck, FaClock, FaExclamationTriangle, FaTimes, FaRupeeSign, FaShoppingCart, FaSearch, FaUser, FaTag } from "react-icons/fa";
import { onAuthStateChanged } from "firebase/auth";
import { db, auth } from "../firebase";

import BlankLayout from "../components/BlankLayout";







// =========================
// HELPERS
// =========================
const getTodayKey = () => {
  const map = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
  const today = map[new Date().getDay()];
  return today === "sun" ? "sat" : today;
};


// temporary - sku permanant read only - raviprabu - remove below to reverse it//
// DYNAMIC BLOCKLIST HANDLED BY DATABASE isLocked FLAG
// (SALESMAN CANNOT EDIT)
//const READ_ONLY_SKUS = [  ];
// temporary //

// =========================
// PAGE
// =========================
function SalesmanOrder() {
  const [userProfile, setUserProfile] = useState(null);
  const [partyList, setPartyList] = useState([]);
  const [party, setParty] = useState(null);

  const [skuMaster, setSkuMaster] = useState({});
  const [skuList, setSkuList] = useState([]);
  const [items, setItems] = useState({});

  const [loading, setLoading] = useState(true);
  const [showPreview, setShowPreview] = useState(false);
  const [search, setSearch] = useState("");


const [submitted, setSubmitted] = useState(false);
const [avgMap, setAvgMap] = useState({});



  const dayKey = getTodayKey();

  // =========================
  // AUTH → LOAD USER PROFILE
  // =========================
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) return;

      const snap = await getDoc(doc(db, "users", user.uid));
      if (!snap.exists()) {
        alert("User profile missing");
        setLoading(false);
        return;
      }

      setUserProfile(snap.data());
    });

    return () => unsub();
  }, []);

  // =========================
  // LOAD PARTY LIST (AFTER PROFILE)
  // =========================
  useEffect(() => {
    if (!userProfile) return;

    const loadParties = async () => {
      
	  
	  
// Raviprabu - hawker / wholesales filter comes here	  
const q = query(
  collection(db, "partyMaster"),
  where("clientId", "==", userProfile.clientId),
  where("partytype", "==", "wholesale")
);

// ends hawker /wholesale filter

      const snap = await getDocs(q);
      const arr = snap.docs.map(d => d.data());

      if (arr.length === 0) {
        alert("No parties found for client");
        setLoading(false);
        return;
      }

      setPartyList(arr);
      
	  //setParty(arr[0]); // default first party - RAVIPRABU - DELETED THE FIRST AUTO ASSIGN CUSTOMER//
      
	  setLoading(false);
    };

    loadParties();
  }, [userProfile]);

  // =========================
  // LOAD SKU MASTER (SAFE)
  // =========================
  useEffect(() => {
    if (!userProfile) return;

    const loadSkuMaster = async () => {
      const q = query(
  collection(db, "skuMaster"),
  where("clientId", "==", userProfile.clientId),
  where("skutype", "in", ["wholesale", "both"]),
  orderBy("swdorder")
);

      const snap = await getDocs(q);

      const map = {};
      const list = {};
      const order = [];

      snap.forEach(d => {
        const data = d.data();
        const sku = data.sku.trim().toUpperCase();
        map[sku] = data;
        list[sku] = "";
        order.push(sku);
      });

      setSkuMaster(map);
      setItems(list);
      setSkuList(order);
    };

    loadSkuMaster();
  }, [userProfile]);




useEffect(() => {
  const loadDayAvg = async () => {
    try {
      const settingsSnap = await getDoc(doc(db, "settings", "google_sheets"));
      const settings = settingsSnap.exists() ? settingsSnap.data() : {};
      const csvUrl = settings.dayAvgCsvUrl;

      if (!csvUrl) {
        throw new Error("Performance Data Link not configured in System Settings.");
      }

      const res = await fetch(csvUrl);
      const text = await res.text();

      const rows = text.trim().split("\n").map(r => r.split(","));
      const header = rows[0].map(h => h.trim().toLowerCase());
      const body = rows.slice(1);
      const map = {};

      body.forEach(rowArr => {
        const row = {};
        header.forEach((h, i) => {
          row[h] = rowArr[i]?.trim();
        });

        const salesman = row.salesman?.toUpperCase();
        const sku = row.sku?.toUpperCase();
        if (!salesman || !sku) return;

        if (!map[salesman]) map[salesman] = {};
        map[salesman][sku] = {
          mon: Number(row.mon || 0),
          tue: Number(row.tue || 0),
          wed: Number(row.wed || 0),
          thu: Number(row.thu || 0),
          fri: Number(row.fri || 0),
          sat: Number(row.sat || 0),
          sun: Number(row.sun || 0),
        };
      });

      setAvgMap(map);
    } catch (err) {
      console.error("Failed to load performance sheet:", err);
    }
  };
  loadDayAvg();
}, []);

//  Temporary raviprabu 05.01.2026 - remove the below function to reverse it. //


// 🔥 AUTO FILL DAY AVG WHEN PARTY CHANGES
useEffect(() => {
  if (!party) return;
  if (!avgMap || Object.keys(avgMap).length === 0) return;

  fillDayAverage();
}, [party]);

// Temporary closed






  // =========================
  // TOTALS
  // =========================
  const totals = useMemo(() => {
    let totalQty = 0;
    let totalAmount = 0;

    const cleanItems = {};
	Object.entries(items).forEach(([sku, qtyRaw]) => {
  const qty = Number(qtyRaw || 0);
  if (qty > 0 ) cleanItems[sku] = qty;

      if (!qty || qty <= 0) return;
      const m = skuMaster[sku];
      if (!m) return;

      const basic = qty * Number(m.Basic_Eway || 0);
      const gst = basic * (Number(m.gst || 0) / 100);
      const cess = basic * (Number(m.cess || 0) / 100);
      const addl = qty * Number(m.addlcess || 0);
      const rebate = qty * Number(m.Rebate || 0);

      totalQty += qty;
      totalAmount += basic + gst + cess + addl + rebate;
    });

    return { totalQty, totalAmount };
  }, [items, skuMaster]);

  // =========================
  // SUBMIT ORDER
  // =========================
  const submitOrder = async () => {
	  
	  if (!party) {
    alert("⚠️ Please select Party Name");
    return;
  }
	  
	  
     setShowPreview(true);
	
  };
  
  
  
  const confirmOrder = async () => {
  if (!party || !userProfile) return;

const cleanItems = {};
Object.entries(items).forEach(([sku, qty]) => {
  const q = Number(qty || 0);
  if (q > 0) cleanItems[sku] = q;
});


  await addDoc(collection(db, "orders"), {
    clientId: userProfile.clientId,
    partyId: party.partyId,
    partyName: party.partyId,
    items: cleanItems,
    totalQty: totals.totalQty,
    totalAmount: totals.totalAmount,
    source: "SALESMAN_APP",
    status: "PENDING",
    payment_mode: party.payment_mode || "Cash",
    createdAt: serverTimestamp(),
  });

setSubmitted(true);


if (navigator.vibrate) {
  navigator.vibrate(200);
}
  alert("Order submitted successfully");

  // RESET FOR NEXT ORDER
  const reset = {};
  skuList.forEach((s) => (reset[s] = ""));
  setItems(reset);
  setShowPreview(false);
};

  
  
  //    added RAVIPRABU ///
  
  if (showPreview) {
  return (
    <BlankLayout>
      <div style={{ padding: 16 }}>
        <h3>Order Preview</h3>

        <div style={{ marginBottom: 20 }}>
          <b>Party:</b> {party?.partyId || "NOT SELECTED"}
        
		</div>

        {Object.entries(items).map(([sku, qty]) => {
  if (!qty || Number(qty) <= 0) return null;

  const numQty = Number(qty);

  // 🔑 FORMAT: add leading 0 + unit M
  const displayQty =
    numQty < 1 && qty.toString().startsWith(".")
      ? `0${qty}`
      : numQty.toString();

  return (
    <div key={sku} style={{ marginBottom: 6 }}>
      
	  {skuMaster[sku]?.Name}
              {skuMaster[sku]?.isLocked && (
  <span style={{ marginLeft: 6, color: "#999", fontSize: 12 }}>
    🔒 Fixed
  </span>
)}
 – 
	  
	  <b>{displayQty} M</b>
    
	
	
	
	</div>
  );
})}


        <hr />

        <div>
          <b>Total Qty:</b> {totals.totalQty.toFixed(2)} <br />
          <b>Total Amount:</b> ₹{totals.totalAmount.toFixed(2)}
        </div>

        <button
          onClick={confirmOrder}
          style={{
            marginTop: 20,
            marginTop: 20,
            marginTop: 20,
            marginTop: 20,
            marginTop: 20,
            marginTop: 20,
            width: "100%",
            padding: 12,
            background: "#198754",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            fontSize: 16,
          }}
        >
          Confirm Order
        </button>

        <button
          onClick={() => setShowPreview(false)}
          style={{
            marginTop: 10,
            width: "100%",
            padding: 10,
            background: "#ddd",
			color: "fff",
            border: "none",
            borderRadius: 6,
			fontSize: 16,
          }}
        >
          Go Back
        </button>
      </div>
    </BlankLayout>
  );
}


//    added RAVIPRABU ///

  if (loading) return <p>Loading...</p>;
  
  
  
  
  
  
  
  
  // ✅ ORDER SUCCESS SCREEN (STEP 3)
if (submitted) {
  return (
    <BlankLayout>
      <div style={{ padding: 40, textAlign: "center" }}>
        <h2 style={{ color: "#198754" }}>✅ Order Submitted</h2>

        <p style={{ fontSize: 16, marginTop: 10 }}>
          Your order has been submitted successfully.
        </p>

        <button
          onClick={() => (window.location.href = "/")}
          style={{
            marginTop: 25,
            padding: "12px 20px",
            fontSize: 16,
            background: "#0d6efd",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Go to Dashboard
        </button>
      </div>
    </BlankLayout>
  );
}

  
  const fillDayAverage = () => {
  
	    

// NEW CHANGE 31.12.2025 10.35 AM RAVIPRABU - TO BRING MANDATORY PARTY SELECTION//
	  
  if (!party) {
    alert("Please select Party first");
    return;
  }

	  
	  
	  
  
  
  if (!party || !avgMap) return;

  const updated = { ...items };

  skuList.forEach((sku) => {
    const avg = avgMap?.[party.partyId]?.[sku]?.[dayKey];
    if (avg && avg > 0) {
      updated[sku] = String(avg);
    }
	
	console.log("Selected party:", party.partyId);
console.log("avgMap keys:", Object.keys(avgMap || {}));
  });

  setItems(updated);
  
  skuList.forEach(sku => {
  console.log(
    "Checking SKU:",
    sku,
    "Sheet value:",
    avgMap?.[party.partyId]?.[sku]
  );
});

  


};

  
  
  

  // =========================
  // UI
  // =========================
  return (
    <BlankLayout>
      
	  <div style={{ padding: 16 }}>
	  
	  <div style={{ fontSize: 13, color: "#666", marginBottom: 4 }}>
    
  </div>
        <h2>Wholesale Order Form – {dayKey.toUpperCase()}</h2>
<h2>WHOLESALE NAME </h2>

        {/* PARTY SELECT */}
        <select
          value={party?.partyId || ""}
          onChange={e =>
		  
		  
            setParty(partyList.find(p => p.partyId === e.target.value))
          }
		  
		  style={{
    width: "100%",
    padding: "10px",
    fontSize: "18px",     // 🔥 INCREASE FONT SIZE
    fontWeight: "600",    // optional (makes it bold & readable)
    borderRadius: "6px",
    border: "1px solid #ccc",
  }}>
          {partyList.map(p => (
            <option key={p.partyId} value={p.partyId}>
              {p.partyId}
            </option>
          ))}
        </select>
		
		
		
		
		<button
  onClick={fillDayAverage}
  style={{
    width: "100%",
    height: 44,
    marginBottom: 12,
    background: "#e9f2ff",
    border: "1px solid #0d6efd",
    borderRadius: 6,
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
  }}
>
  Fill Day Average
</button>


		
		
		
		
		
		
		
		
		
		
		
		<input
  type="text"
  placeholder="Search SKU (eg: GFK, GOLD, CLASSIC)"
  value={search}
  onChange={(e) => setSearch(e.target.value)}
  style={{
    width: "100%",
    height: 44,
    marginBottom: 12,
    padding: "0 10px",
    fontSize: 16,
    borderRadius: 6,
    border: "1px solid #aaa",
  }}
/>

		
		
		

{skuList
  .filter((sku) =>
    skuMaster[sku]?.sku?.toLowerCase().includes(search.toLowerCase())
  )
  .map((sku) => (

          
		  
		  
		  <div
  key={sku}
  style={{
    marginBottom: 12,
    padding: 10,
    border: "1px solid #ddd",
    borderRadius: 8,
    background: "#fff",
  }}
>
  <div
    style={{
      fontSize: 15,
      fontWeight: 600,
      marginBottom: 6,
      color: "#000",
    }}
  >
    {skuMaster[sku]?.sku}
  </div>

  <input
    type="number"
    min="0"
    step="1"
    value={items[sku]}
    
	// termporary - raviprabu - remove this to reverse
										readOnly={skuMaster[sku]?.isLocked}
										disabled={skuMaster[sku]?.isLocked}

// temporary
	
	onChange={(e) => {
  const val = e.target.value;











  // allow empty input
  if (val === "") {
    setItems({ ...items, [sku]: "" });
    return;
  }

  // allow only numbers
  if (!/^\d*(\.\d{0,3})?$/.test(val)) return;


  setItems({ ...items, [sku]: val });
}}

	
	
	
	
	
    style={{
  width: "100%",
  height: 44,
  fontSize: 18,
  padding: "0 10px",
  borderRadius: 6,
  border: "1px solid #aaa",
									background: skuMaster[sku]?.isLocked ? "#FFFF00" : "#fff",
									color: skuMaster[sku]?.isLocked ? "#0B0000" : "#000",
}}

  />
</div>

		  
		  
		  
		  
		  
		  
		  
		  
		  
		  
		  
		  
        ))}


{/* =========================
    TOTALS BAR
========================= */}
<div
  style={{
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    background: "#fff",
    borderTop: "1px solid #ddd",
    padding: 0,
	paddingBottom: "env(safe-area-inset-bottom)",
    zIndex: 1000,
  }}
>
  <div style={{ 
     display: "flex",
	 justifycontent: "space-between",
  fontSize: 16, 
  fontweight:600,
  marginBottom: 8 }}>
    <b>Total Qty:</b>   {totals.totalQty.toFixed(2)}   
    <b>    {">>>>"}         Total Amount:</b> ₹{totals.totalAmount.toFixed(2)}
  </div>

  <button
    onClick={submitOrder}
	disabled={submitted}
    style={{
      width: "100%",
      padding: 10,
      fontSize: 16,
	  
      background: submitted ? "#aaa" : "#198754",
	  color: "#fff",
      border: "none",
      borderRadius: 8,
      fontWeight: 800,
	  cursor: submitted ? "not-allowed" : "pointer",
	  
    }}
  >
    {submitted ? "Order Submitted" : "Submit Order"}
  </button>
</div>
         </div> 
    </BlankLayout>
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
  );
}

export default SalesmanOrder;
